import { render, staticRenderFns } from "./Proformas.vue?vue&type=template&id=595cb5aa&scoped=true"
import script from "./Proformas.vue?vue&type=script&lang=js"
export * from "./Proformas.vue?vue&type=script&lang=js"
import style0 from "./Proformas.vue?vue&type=style&index=0&id=595cb5aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595cb5aa",
  null
  
)

export default component.exports